import React from 'react'
import './Sidebar.css'
import ScriptInput from './ScriptInput'
import VoiceSettings from './VoiceSettings'
import UnifiedSettings from './UnifiedSettings'
import ActionButtons from './ActionButtons'

/**
 * 메인 사이드바 컨테이너 컴포넌트
 */
function Sidebar({ 
  projectName,
  setProjectName,
  scriptTitle,
  setScriptTitle,
  script,
  setScript,
  selectedVoice,
  setSelectedVoice,
  titleSettings,
  setTitleSettings,
  subtitleSettings,
  setSubtitleSettings,
  videoSettings,
  setVideoSettings,
  sections,
  parseScript,
  generateAllTTS,
  isGeneratingAllTTS,
  onTitleSettingsChange,
  onSubtitleSettingsChange,
  onVideoSettingsChange,
  onBulkImageUpload,
  onBulkAudioUpload,
  onMergeVideos,
  isOpen
}) {
  return (
    <div className={`sidebar ${isOpen ? '' : 'closed'}`}>
      <div className="sidebar-content">
        <ScriptInput 
          projectName={projectName}
          setProjectName={setProjectName}
          scriptTitle={scriptTitle}
          setScriptTitle={setScriptTitle}
          script={script}
          setScript={setScript}
          parseScript={parseScript}
          titleSettings={titleSettings}
          setTitleSettings={setTitleSettings}
          onTitleSettingsChange={onTitleSettingsChange}
        />

        <UnifiedSettings 
          titleSettings={titleSettings}
          setTitleSettings={setTitleSettings}
          subtitleSettings={subtitleSettings}
          setSubtitleSettings={setSubtitleSettings}
          videoSettings={videoSettings}
          setVideoSettings={setVideoSettings}
          onTitleSettingsChange={onTitleSettingsChange}
          onSubtitleSettingsChange={onSubtitleSettingsChange}
          onVideoSettingsChange={onVideoSettingsChange}
        />

        <VoiceSettings 
          selectedVoice={selectedVoice}
          setSelectedVoice={setSelectedVoice}
        />

        <ActionButtons 
          sections={sections}
          generateAllTTS={generateAllTTS}
          isGeneratingAllTTS={isGeneratingAllTTS}
          onBulkImageUpload={onBulkImageUpload}
          onBulkAudioUpload={onBulkAudioUpload}
          onMergeVideos={onMergeVideos}
          subtitleSettings={subtitleSettings}
          videoSettings={videoSettings}
          selectedVoice={selectedVoice}
          titleSettings={titleSettings}
        />
      </div>
    </div>
  )
}

export default Sidebar
